module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/034-china-2561f7da93bbd81c180fb5963af6db51.svg";